var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"date",attrs:{"data-test":"group-date"}},[_vm._v(" "+_vm._s(_vm.formattedStartDate())+" - "+_vm._s(_vm.formattedEndDate())+" "),_c('group-session-time',{attrs:{"session":_vm.firstSession}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }